var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-channel-janus-settings"},[_c('sidebar-addons',_vm._b({},'sidebar-addons',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }